import { colors } from './colors';

export const DEFAULT_COLOR = colors.midnightCharcoal;
export const DEFAULT_BACKGROUND = '#ffffff';
